export default {"link":"-y9Hi","iconContainer":"B-KmT","linkIcon":"rNPWN","linkText":"dulP4","link0":"yvvau","link1":"_6-TmT","link3":"zbatY"};